





































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { axiosM, axiosC, resHandle } from "@/plugins/axios";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    Pagination
  }
})
export default class ProjectCreateSecondNormalComponent extends Vue {
  @Prop()
  private cZu: any;
  // 分页
  private currentPage: any = 1;
  private totalPage: any = 1;
  private totalNum: any = 0;
  private pageSize: any = 10;
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "1";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 数据
  private messages: any[] = [];

  /**
   * @description 开始从四诊设备导入数据
   */
  private startImport() {
    this.$emit("cStateChange", "import");
  }
  /**
   * @description 获取当前分组下的患者
   */
  private fetchPatients() {
    if (!this.cZu.group_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.cZu.project_id,
        group_id: this.cZu.group_id,
        current_page: this.currentPage,
        order_field: this.cSortField,
        order_value: this.cSortValue,
        page_count: this.pageSize
      }
    };
    axios.get("api/project/patients", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.messages = data.data.patients;
        this.totalPage = data.data.total_page;
        this.totalNum = data.data.total_count;
        this.checkAllMessages(false);
        this.autoCheckSelectedMessages(true);
        const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
        this.checkAll = checkedCount === this.messages.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.messages.length;
      });
    });
  }
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.messages.forEach((message: any, index: number) => {
      this.$set(this.messages[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.messages.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.messages.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.messages.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.messages.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    console.log(ev);
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      this.addAllMessagesToSelectedMessages();
    } else {
      this.checkAllMessages(false);
      this.deleteAllMessagesFromSelectedMessages();
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      this.addOneMessageToSelectedMessages(item);
    } else {
      this.deleteOneMessageFromSelectedMessages(item);
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.messages.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.messages.length;
  }
  /**
   * @description 删除所有选择的数据
   */
  private deleteSelectedMessages() {
    if (this.selectedMessages.length === 0) {
      this.$message.error("请至少选择一条数据");
      return;
    }
    const idList: any[] = [];
    this.selectedMessages.forEach((message: any) => {
      idList.push(message.patient_id);
    });
    const params: any = {
      data: {
        project_id: this.cZu.project_id,
        group_id: this.cZu.group_id,
        patient_ids: idList
      }
    };
    axios.delete("api/project/patients", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.selectedMessages = [];
        this.currentPage = 1;
        this.fetchPatients();
      });
    });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchPatients();
  }
}
